import {
  ArrowRight, Banknote, Bell, Building2, Calendar, ChartColumn, Check, ChevronDown,
  ChevronRight, ChevronUp, CircleArrowDown, CircleArrowUp, CircleCheck, ClipboardList,
  Clock, Coins, Columns3, Copy, CreditCard, Droplets, Eye, EyeOff, ExternalLink, Files, FilePen,
  FileText, FlaskConical, Fuel, Gift, Globe, House, Info, Key, Layers, Leaf, Lock, LogOut, Map,
  Menu, MessageCircle, MousePointerClick, NotebookText, Package, Pencil, Play, Plus,
  Receipt, Scale, Search, Shield, Smartphone, SprayCan, Sprout, Tractor, Trash2, TrendingUp,
  TriangleAlert, Truck, User, Users, Warehouse, Wheat, Wrench, X,
} from 'lucide-react';

/**
 * Ícones do sistema.
 *
 * Antes a iconografia era emoji: ~55 glifos espalhados entre `navigation.js`,
 * `EmptyState` e as páginas. Emoji é desenhado pelo sistema operacional — muda
 * de forma entre Windows, Android e iPhone, vem sempre multicolorido e não
 * acompanha o estado do elemento (ativo, desabilitado, perigo). Um SVG de
 * traço herda `currentColor` e resolve os três problemas.
 *
 * As chaves são o SIGNIFICADO no AgriGest, não o desenho. Assim, trocar o
 * símbolo de "conta a pagar" é mexer numa linha aqui, e não caçar o emoji em
 * dez arquivos. Era exatamente esse acoplamento que fazia 🗺️ aparecer em duas
 * rotas diferentes ao mesmo tempo.
 */
const REGISTRO = {
  // Ciclo da safra
  safra: Sprout,
  manejo: Leaf,
  insumo: FlaskConical,
  semente: Wheat,
  defensivo: Shield,
  adubo: Droplets,
  pulverizacao: SprayCan,
  combustivel: Fuel,

  // Produção
  colheita: Truck,
  estoque: Package,
  armazem: Warehouse,
  venda: ClipboardList,

  // Relatórios
  relatorio: Files,
  resultado: ChartColumn,
  producao: TrendingUp,
  'comparar-areas': Columns3,
  'comparar-safras': Scale,

  // Propriedade
  lavoura: Map,
  maquinario: Tractor,
  manutencao: Wrench,

  // Financeiro
  'livro-caixa': NotebookText,
  'conta-pagar': CircleArrowUp,
  'conta-receber': CircleArrowDown,
  dinheiro: Banknote,
  receita: Coins,
  assinatura: CreditCard,
  nota: Receipt,

  // Sistema
  inicio: House,
  usuarios: Users,
  usuario: User,
  notificacao: Bell,
  busca: Search,
  suporte: MessageCircle,
  sair: LogOut,
  presente: Gift,
  cadeado: Lock,
  documento: FileText,
  editar: Pencil,
  'novo-registro': FilePen,
  adicionar: Plus,
  excluir: Trash2,
  copiar: Copy,
  calendario: Calendar,
  relogio: Clock,
  empresa: Building2,
  camadas: Layers,
  toque: MousePointerClick,
  menu: Menu,
  play: Play,
  chave: Key,
  celular: Smartphone,
  web: Globe,

  // Estados e navegação
  olho: Eye,
  'olho-fechado': EyeOff,
  ok: Check,
  concluido: CircleCheck,
  fechar: X,
  alerta: TriangleAlert,
  info: Info,
  'seta-direita': ArrowRight,
  'seta-externa': ExternalLink,
  'chevron-baixo': ChevronDown,
  'chevron-cima': ChevronUp,
  'chevron-direita': ChevronRight,
};

/**
 * @param {string} nome    chave do REGISTRO
 * @param {number} tamanho lado do quadrado em px (padrão 20)
 * @param {string} titulo  quando o ícone carrega significado sozinho (sem texto
 *                         ao lado), passe um título: ele vira o rótulo acessível.
 *                         Sem título o ícone é tratado como decoração.
 */
export default function Icon({ nome, tamanho = 20, titulo, className, strokeWidth = 1.6, ...resto }) {
  const Componente = REGISTRO[nome];
  if (!Componente) return null;

  return (
    <Componente
      size={tamanho}
      strokeWidth={strokeWidth}
      className={className}
      aria-hidden={titulo ? undefined : true}
      role={titulo ? 'img' : undefined}
      aria-label={titulo}
      {...resto}
    />
  );
}

export const ICONES_DISPONIVEIS = Object.keys(REGISTRO);
